import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const PickemProductIcon = (props: SvgProps & { fill?: string }) => (
    <Svg width={16} height={16} {...props} fill="none" viewBox="0 0 16 16">
        <Path
            stroke={props.fill || ds.colorValue.icon.primary}
            strokeLinecap="square"
            strokeLinejoin="round"
            strokeWidth={1.25}
            d="M4.667 10V2m0 0L2 4.667M4.667 2l2.666 2.667m4 1.333v8m0 0L14 11.333M11.333 14l-2.666-2.667"
        />
    </Svg>
);
